'use client';
// External Libs
import React, { forwardRef, Ref } from 'react';
// Libs
import './input-label';
import { InputLabelProps } from './input-label.interfaces';
import { Label } from './input-label.styles';

const InputLabel = forwardRef((props: InputLabelProps, ref: Ref<HTMLLabelElement>) => {
  return <Label ref={ref} {...props}></Label>;
});

export default InputLabel;
